import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
    clearScrollTarget,
    setScrollTarget,
    setActiveSection,
} from "../../../store/slices/scrollSlice";
import { fetchEmployees } from "../../../store/slices/employeeSlice";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { setcurrentLeadID } from "../../../store/slices/pageSlice";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import logo from "../../../assets/CombinedLogo.svg"
import { fetchCompanyProfiles, saveOrUpdateCompanyProfile } from "../../../store/slices/companyProfileSlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdminLoader from "../../common/loader/AdminLoader";
import { useSnackbar } from "notistack";
// import { MdSearch } from "react-icons/md";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HomeIcon from '@mui/icons-material/Home';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import { setShowWizard } from "../../../store/slices/WizardSlice/WizardSlice";
import Wizard from "../../../pages/Operations/Wizard/Wizard";
import InventoryIcon from '@mui/icons-material/Inventory';
import { clearWizardState, setCreatedProject, setEditProjectID, setOperationProjectStatus, setWizardPlanState, setWizardProjectState } from "../../../store/slices/WizardSlice/wizardStepSlice";
import GroupIcon from '@mui/icons-material/Group';
import { fetchGroups } from "../../../store/slices/groupSlice";
import { setSidebar, setSidebarInventoryGroup, clearAllSidebarSelections } from "../../../store/slices/Sidebar/SidebarStateSlice";
import { clearActiveBucketName } from "../../../store/slices/Sidebar/ProcessGuideSlice";
import { setToolGuideActive } from "../../../store/slices/Sidebar/ToolGuideSlice";
import ToolGuideSidebarItem from "../../../features/toolGuide/ToolGuideSidebarItem";
import { deleteLeadId } from "../../../store/slices/lead/leadIdGenerationSlice";
import { invalidateLeadsCache, fetchEmployeeAuthData, fetchLeads } from "../../../store/slices/leadsSlice";
import { hasViewOrFullAccess } from "../../../utils/featureAccessUtils";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { getInventoryByCreatedBy } from "../../../store/slices/InventorySlice";
import { getAllAssemblyInventory } from "../../../store/slices/assemblyInventorySlice";

const SidebarNew = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const { employees } = useSelector((state) => state.employees);
    const { session } = useSelector((state) => state.session);
    const showWizard = useSelector((state) => state.wizard.showWizard);
    const { profiles } = useSelector(state => state.companyProfile);
    const Auth = localStorage.getItem("auth");
    const [showServiceDropdown, setShowServiceDropdown] = useState(false);
    const [selectedServiceTypes, setSelectedServiceTypes] = useState("");
    const [isLoading, SetisLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [packageData, setPackageData] = useState("");
    const [loggedinuser, setLoggedinuser] = useState("");
    const Roles = localStorage.getItem("Roles");
    // const servicetype = localStorage.getItem("servicetype");
    // const [showGroup, setshowGroup] = useState(false);
    const [showhardwaresetting, setshowhardwaresetting] = useState(false);
    const [showInventoryDropdown, setShowInventoryDropdown] = useState(false);
    const SidebarGroup = useSelector((state) => state.sidebar.SidebarGroup);
    const SidebarInventoryGroup = useSelector((state) => state.sidebar.SidebarInventoryGroup);
    const groupsFromSlice = useSelector((state) => state.group?.group || []);

    // const [showoption, setshowoption] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpens, setIsOpens] = useState(false);
    const [selectedGroupoption, setselectedGroupoption] = useState('');
    const [isOpenwizard, setisOpenwizard] = useState(false);
    const currentLeadID = useSelector((state) => state.page.currentLeadID);

    // const [showInventory, setShowInventory] = useState(false);

    console.log("currentLeadID", currentLeadID)
    useEffect(() => {
        dispatch(fetchEmployees());
        dispatch(fetchAllProjects());
        dispatch(fetchCompanyProfiles());
        dispatch(fetchGroups());
        dispatch(setcurrentLeadID());
    }, [dispatch]);

    const handleDeleteLeadID = useCallback(async () => {
        if (!currentLeadID) return;
        try {
            dispatch(
                deleteLeadId({
                    generatedLeadId: currentLeadID,
                })
            );
        } catch (error) {
            console.error("Generate Lead ID failed", error);
        }
    }, [dispatch, currentLeadID]);

    useEffect(() => {
        if (profiles && profiles.length > 0) {
            const packages = profiles[0].subscriptionpackage;
            if (packages) {
                // Only update if the package value has actually changed to prevent unnecessary toggling
                setPackageData((prev) => {
                    // If packageData is already set and matches, don't update
                    if (prev === packages) {
                        return prev;
                    }
                    return packages;
                });
            }
        }
        // Don't clear packageData if profiles is temporarily empty - keep the last known value
    }, [profiles]);

    const wizardStateToClear = () => {
        dispatch(setCreatedProject([]))
        dispatch(setEditProjectID(""))
        dispatch(setWizardPlanState(""))
        dispatch(setWizardProjectState(""))
        dispatch(setOperationProjectStatus(""))
        dispatch(clearWizardState())
        navigate("/dashboard")
    }

    useEffect(() => {
        const userEmail = localStorage.getItem("email");

        const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
        console.log("gfdfgdf", currentEmployee)
        if (currentEmployee) {
            setLoggedinuser(currentEmployee)

        } else {
            setLoggedinuser()

        }
    }, [employees]);

    useEffect(() => {
        if (!employees?.length || !session?.email) return; // wait until data is ready

        const LoggedEmp = employees.find((emp) => emp.EmpEmail === session.email);

        if (
            LoggedEmp?.customRoles?.includes("project manager") &&
            LoggedEmp?.servicetype
        ) {
            localStorage.setItem("servicetype", LoggedEmp.servicetype);
        }
    }, [employees, session]);
    const dropdownRef = useRef(null);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        handleDeleteLeadID()
    };
    const toggleDropdowns = () => {
        setIsOpens(!isOpens);
    };
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const serviceType = localStorage.getItem("servicetype"); // 👈 get servicetype from localStorage
    const [showContact, setShowContact] = useState(false); // 👈 add state

    const [userLevel, SetUserLevel] = useState("");
    const [, setcustomRole] = useState([]);
    const resolvedAuthLevel = (
        loggedinuser?.EmpAuthLevel ||
        session?.auth ||
        userLevel ||
        ""
    ).toString().trim().toUpperCase();
    const isL0User = resolvedAuthLevel === "L0";
    const empAuthLevel = (loggedinuser?.EmpAuthLevel ?? "")
        .toString()
        .trim()
        .toUpperCase();
    const selectedPackages = (packageData || "")
        .toUpperCase()
        .split(/[,\s/|+-]+/)
        .filter((pkg) => pkg === "ERP" || pkg === "CRM")
        .filter((pkg, index, arr) => arr.indexOf(pkg) === index);

    useEffect(() => {
        const authLevel = session?.auth || localStorage.getItem("auth");

        const rawRoles = session?.customRoles || localStorage.getItem("Roles");

        const customRoles = Array.isArray(rawRoles)
            ? rawRoles
            : typeof rawRoles === "string"
                ? [rawRoles]
                : [];

        if (authLevel === "L4" && customRoles.length > 0) {
            setcustomRole(customRoles);
        }
    // Normalize auth level so permission checks (e.g. "L0") don't fail due to case/whitespace.
    SetUserLevel((authLevel ?? "").toString().trim().toUpperCase());
    }, [session]);

    const [showLogout, setshowlogout] = useState(false);
    const [modalOpen] = useState(true);
    const [openSubMenus, setOpenSubMenus] = useState({});
    const popupRef = useRef(null);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setshowlogout(false); // Close the popup if clicked outside
        }
    };

    useEffect(() => {
        if (showLogout) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showLogout]);

    const wizardRef = useRef(null);

    useEffect(() => {
        const handleClickOutsidewizard = (event) => {
            if (wizardRef.current && !wizardRef.current.contains(event.target)) {
                dispatch(setShowWizard(false));
            }
        };
        if (showWizard) {
            document.addEventListener("mousedown", handleClickOutsidewizard);
        } else {
            document.removeEventListener("mousedown", handleClickOutsidewizard);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutsidewizard);
        };
    }, [showWizard, dispatch]); // Changed from showLogout to showWizard

    const [clickedItem, setClickedItem] = useState("");
    const settingsMenu = useMemo(
        () => [
            {
                name: "Client Ratings",
                path: "/dashboard/client-ratings",
                permissionLevels: ["L3"],
            },
            {
                name: "Company Profile",
                path: "/dashboard/company-profile",
                permissionLevels: ["L0", "L1"],
            },
            {
                name: "Add Group",
                path: "/dashboard/add-group",
                permissionLevels: ["L0", "L1"],
            },

            {
                name: "Lead Type",
                path: "/dashboard/lead-types",
                permissionLevels: ["L0", "L1"],
            },
            {
                name: "Status",
                path: "/dashboard/status",
                permissionLevels: ["L0", "L1"],
            },
            {
                name: "Source",
                path: "/dashboard/source",
                permissionLevels: ["L0", "L1"],
            },
            {
                name: "Employees",
                path: "/dashboard/employees",
                permissionLevels: ["L0", "L1"],
            },
            {
                name: "Add Member",
                path: "/dashboard/my-member",
                permissionLevels: ["L3"],
            },
            {
                name: "Hourly Rates & Expenses",
                path: "/dashboard/hourly-rates",
                permissionLevels: ["L3"],
            },
            {
                name: "Hourly Rates & Expenses",
                path: "/dashboard/hourly-rates-manager",
                permissionLevels: ["L4"],
            },
            {
                name: "G&A and Tax Rates",
                path: "/dashboard/g-a-tax",
                permissionLevels: ["L3"],
            },
            {
                name: "Quotation Template",
                path: "/dashboard/quotation-template",
                permissionLevels: ["L3"],
            },
            {
                name: "Assembly",
                path: "/dashboard/assembly",
                permissionLevels: ["L4"],
            },
            {
                name: "Subpart",
                path: "/dashboard/hardware",
                permissionLevels: ["L4"],
            },
            {
                name: "Group",
                path: "/dashboard/addgroup",
                permissionLevels: ["L4"],
            },

            {
                name: "G&A and Tax Rates",
                path: "/dashboard/g-a-tax",
                permissionLevels: ["L2"],
            },
            {
                name: "Client Master",
                path: "/dashboard/client-master",
                permissionLevels: ["L3"],
            },
        ],
        []
    );

    const filteredSettingsMenu = useMemo(() => {
        if (Auth === "L3") {
            if (clickedItem === "Lead Tracker") {
                return settingsMenu.filter((item) =>
                    [
                        "Company Profile",
                        "Client Ratings",
                        "Add Member",
                        "Quotation Template",
                    ]?.includes(item.name)
                );
            } else if (clickedItem === "Operations Tracker") {
                return settingsMenu.filter((item) =>
                    ["Hourly Rates & Expenses", "Subpart", "Assembly", "Group"]?.includes(item.name)
                );
            } else if (clickedItem === "Profit and Loss Tracker") {
                return settingsMenu.filter((item) =>
                    ["G&A and Tax Rates", "Hourly Rates & Expenses"]?.includes(item.name)
                );
            }

            return settingsMenu;
        } else {
            return settingsMenu;
        }


    }, [clickedItem, Auth, settingsMenu]);

    // const MenuArray = useMemo(() => {
    //     const baseMenu = [
    //         {
    //             name: "Lead Tracker",
    //             path: "/dashboard",
    //             bgColor: "bg-[#ffe1d7]",
    //             permissionLevels: ["L0", "L1", "L3"],
    //         },
    //         {
    //             name: "Add Lead",
    //             path: "/dashboard/add-lead",
    //             bgColor: "bg-[#ffe1d7]",
    //             permissionLevels: ["L0", "L1", "L3"],
    //         },
    //         {
    //             name: "Lead Reports",
    //             path: "/dashboard/leadreport",
    //             bgColor: "bg-[#ffe1d7]",
    //             permissionLevels: ["L0", "L1", "L3"],
    //         },
    //         {
    //             name: "Operations Tracker",
    //             path: "/dashboard",
    //             bgColor: "bg-[#ffe1d7]",
    //             permissionLevels: ["L0", "L1", "L3", "L4"],
    //         },
    //         {
    //             name: "Profit and Loss Tracker",
    //             path: "/dashboard",
    //             bgColor: "bg-[#ff9f1c]",
    //             permissionLevels: ["L0", "L1", "L2", "L3","L4"],
    //         },
    //     ];

    //     return baseMenu;
    // }, []);

    const MenuArray = useMemo(() => {
        const baseMenu = [
            {
                name: "Lead Tracker",
                path: "/dashboard",
                bgColor: "bg-[#ffe1d7]",
                permissionLevels: ["L0", "L1", "L3"],
            },
            {
                name: "Add Lead",
                path: "/dashboard/add-lead",
                bgColor: "bg-[#ffe1d7]",
                permissionLevels: ["L0", "L1", "L3"],
            },
            {
                name: "Lead Reports",
                path: "/dashboard/leadreport",
                bgColor: "bg-[#ffe1d7]",
                permissionLevels: ["L0", "L1", "L3"],
            },
            {
                name: "Operations Tracker",
                path: "/dashboard",
                bgColor: "bg-[#ffe1d7]",
                permissionLevels: ["L0", "L1", "L3", "L4"],
            },
            {
                name: "Profit and Loss Tracker",
                path: "/dashboard",
                bgColor: "bg-[#ff9f1c]",
                permissionLevels: ["L0", "L1", "L2", "L3", "L4"],
            },
        ];

        return baseMenu;
    }, []);

    const toggleSubMenu = (menuName) => {
        setOpenSubMenus((prev) => {
            const dashboardGroup = ["Dashboard", "Lead Tracker", "Operations Tracker", "Profit and Loss Tracker"];
            const isDashboardGroup = dashboardGroup.includes(menuName);
            if (menuName === "Settings") {
                return { Settings: !prev["Settings"] };
            }
            if (isDashboardGroup) {
                const newState = { ...prev };
                delete newState["Settings"]; // close Settings if open
                return {
                    ...newState,
                    [menuName]: !prev[menuName], // toggle clicked one
                };
            }
            return { [menuName]: !prev[menuName] };
        });
    };

    const ImageNavigate = () => {
        navigate(`/dashboard`);
        setClickedItem("");
        setSelectedDash("")
        setIsProcessGuideActive(false)
        dispatch(clearActiveBucketName());
        dispatch(setcurrentLeadID());
        // setshowoption(false)
        setshowhardwaresetting(false)
        handleDeleteLeadID()

    };

    const dropdownRefService = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRefService.current &&
                !dropdownRefService.current.contains(event.target)
            ) {
                setShowServiceDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handlePackageSelection = (packageName) => {
        setSelectedServiceTypes(packageName);
        setShowServiceDropdown(false);
    };

    const handleProfile = async () => {
        handleDeleteLeadID()
        if (!selectedServiceTypes) {
            enqueueSnackbar("Please select a package", {
                variant: "warning",
            });
            return;
        }
        const formData = new FormData();
        formData.append('companyname', profiles[0].companyname);
        formData.append('companyemail', profiles[0].companyemail);
        formData.append('companylink', profiles[0].companylink);
        formData.append('companyaddress', profiles[0].companyaddress);
        formData.append('companyaddresstwo', profiles[0].companyaddresstwo);
        formData.append('companypincode', profiles[0].companypincode);
        formData.append('companycity', profiles[0].companycity);
        formData.append('companylogo', profiles[0].companylogo);
        formData.append('subscriptionpackage', selectedServiceTypes);
        SetisLoading(true);
        try {
            await dispatch(saveOrUpdateCompanyProfile(formData)).unwrap();
            enqueueSnackbar("Package Updated Successfully", {
                variant: "success",
            });
        } catch (error) {
            console.error("Failed to update company profile:", error);
            const errorMessage =
                error?.error ||
                error?.message ||
                "Something went wrong. Please try again.";
            enqueueSnackbar(errorMessage, {
                variant: "error",
            });
        } finally {
            SetisLoading(false);
            dispatch(fetchCompanyProfiles());
            setIsModalOpen(false);
        }
    };

    const [selectedDash, setSelectedDash] = useState("");
    const [isProcessGuideActive, setIsProcessGuideActive] = useState(false);
    const [showProcessGuidePanel, setShowProcessGuidePanel] = useState(false);
    const [, setSelectedGuideStep] = useState(null);
    const activeBucketName = useSelector((state) => state.processGuide.activeBucketName);
    console.log("selectedDash", selectedDash)

    useEffect(() => {
        const menuItemByPath = {
            "/dashboard/add-lead": "Add Lead",
            "/dashboard/leadreport": "Lead Reports",
            "/dashboard/lead-report": "Lead Reports",
            "/dashboard/add-group": "Add Group",
            "/dashboard/company-profile": "Company Profile",
            "/dashboard/lead-types": "Lead Type",
            "/dashboard/status": "Status",
            "/dashboard/source": "Source",
            "/dashboard/employees": "Employees",
        };

        const redirectedItem = location.state?.selectedDash;
        const resolvedSelectedItem = redirectedItem || menuItemByPath[location.pathname];

        if (!resolvedSelectedItem) return;

        setSelectedDash(resolvedSelectedItem);
        setOpenSubMenus((prev) => ({
            ...prev,
            Settings: true,
        }));
    }, [location.pathname, location.state]);

    const hasConfiguredFeatureAccess = useMemo(
        () => Array.isArray(loggedinuser?.featureAccess) && loggedinuser.featureAccess.length > 0,
        [loggedinuser]
    );

    // Strict featureAccess: for Lead Tracker-related items, require FULL ACCESS (hasFeatureAccess);
    // for other items, View Only or Full Access is sufficient.
    const canAccessMenuItem = useCallback((menu) => {
        if (!hasConfiguredFeatureAccess) {
            return menu.permissionLevels?.includes(userLevel);
        }

        if (menu.name === "Add Lead") {
            if (loggedinuser?.EmpAuthLevel === "L0") {
                return menu.permissionLevels?.includes(userLevel);
            }
            return (
                hasViewOrFullAccess(loggedinuser, "ADD LEAD") ||
                hasViewOrFullAccess(loggedinuser, "EDIT LEAD") ||
                hasViewOrFullAccess(loggedinuser, "IMPORT LEADS")
            );
        }
        if (menu.name === "Lead Reports") {
            if (loggedinuser?.EmpAuthLevel === "L0") {
                return menu.permissionLevels?.includes(userLevel);
            }
            return (
                hasViewOrFullAccess(loggedinuser, "LEAD REPORTS") ||
                hasViewOrFullAccess(loggedinuser, "DOWNLOAD TEMPLATE") ||
                hasViewOrFullAccess(loggedinuser, "ATTACHMENTS")
            );
        }
        if (menu.name === "Lead Tracker") {
            if (loggedinuser?.EmpAuthLevel === "L0") {
                return menu.permissionLevels?.includes(userLevel);
            }
            const canSeeAddLead =
                hasViewOrFullAccess(loggedinuser, "ADD LEAD") ||
                hasViewOrFullAccess(loggedinuser, "EDIT LEAD") ||
                hasViewOrFullAccess(loggedinuser, "IMPORT LEADS");
            const canSeeLeadReports =
                hasViewOrFullAccess(loggedinuser, "LEAD REPORTS") ||
                hasViewOrFullAccess(loggedinuser, "DOWNLOAD TEMPLATE") ||
                hasViewOrFullAccess(loggedinuser, "ATTACHMENTS");
            return canSeeAddLead || canSeeLeadReports;
        }
        if (menu.name === "Operations Tracker") {
            const level = loggedinuser?.EmpAuthLevel || userLevel;
            if (level === "L2" || level === "L5") {
                return false;
            }
            const hasAnyOperationTrackerAccess =
                hasViewOrFullAccess(loggedinuser, "MY REQUEST") ||
                hasViewOrFullAccess(loggedinuser, "TASK IN HAND") ||
                hasViewOrFullAccess(loggedinuser, "UTILISATION REPORT") ||
                hasViewOrFullAccess(loggedinuser, "MY TRAININGS");
            return hasAnyOperationTrackerAccess;
        }
        if (menu.name === "Profit and Loss Tracker") {
            const level = loggedinuser?.EmpAuthLevel || userLevel;
            if (level === "L2") {
                return hasConfiguredFeatureAccess && hasViewOrFullAccess(loggedinuser, "PROFIT AND LOSS");
            }
            if (level === "L4") {
                return (
                    hasViewOrFullAccess(loggedinuser, "PROFIT AND LOSS") ||
                    hasViewOrFullAccess(loggedinuser, "G&A AND TAX") ||
                    hasViewOrFullAccess(loggedinuser, "GROSS PROFIT TRACKER")
                );
            }
            return ["L0", "L1", "L3"].includes(level);
        }

        if (menu.name === "Add Member") {
            // When feature access is configured, show Add Member in sidebar only if the user
            // has at least View Only or Full Access to any Add/Edit/Delete member action.
            return (
                hasViewOrFullAccess(loggedinuser, "ADD MEMBER ADD MEMBER") ||
                hasViewOrFullAccess(loggedinuser, "ADD MEMBER EDIT MEMBER") ||
                hasViewOrFullAccess(loggedinuser, "ADD MEMBER DELETE MEMBER")
            );
        }

        // L3 Hourly Rates & Expenses (Sales Hourly Rates screen)
        if (menu.name === "Hourly Rates & Expenses" && menu.permissionLevels?.includes("L3")) {
            // Sidebar access for L3 is controlled via the Sales Hourly Rates feature set.
            return (
                hasViewOrFullAccess(
                    loggedinuser,
                    "SALES HOURLY RATES ADD HOURLY RATES"
                ) ||
                hasViewOrFullAccess(
                    loggedinuser,
                    "SALES HOURLY RATES EDIT HOURLY RATES"
                ) ||
                hasViewOrFullAccess(
                    loggedinuser,
                    "SALES HOURLY RATES DELETE HOURLY RATES"
                )
            );
        }

        return menu.permissionLevels?.includes(userLevel);
    }, [hasConfiguredFeatureAccess, userLevel, loggedinuser]);

    const canSeeWizard = useMemo(
        () => hasConfiguredFeatureAccess && hasViewOrFullAccess(loggedinuser, "WIZARD WIZARD FEATURE"),
        [hasConfiguredFeatureAccess, loggedinuser]
    );

    const canSeeClientMaster = useMemo(
        () => hasViewOrFullAccess(loggedinuser, "CLIENT MASTER EDIT CLIENT DATA"),
        [loggedinuser]
    );

    const canSeeClientRatings = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "CLIENT RATINGS CREATE CLIENT RATING") ||
            hasViewOrFullAccess(loggedinuser, "CLIENT RATINGS DOWNLOAD CLIENT RATING")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    const canSeeQuotationTemplate = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "QUOTATION TEMPLATE CREATE QUOTATION TEMPLATE") ||
            hasViewOrFullAccess(loggedinuser, "QUOTATION TEMPLATE EDIT QUOTATION TEMPLATE") ||
            hasViewOrFullAccess(loggedinuser, "QUOTATION TEMPLATE DOWNLOAD QUOTATION TEMPLATE")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    const canSeeTaxRates = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        // L2 (finance person): G&A and Tax Rates visible only with Full Access to G&A AND TAX
        if (loggedinuser?.EmpAuthLevel === "L2") {
            return hasViewOrFullAccess(loggedinuser, "G&A AND TAX");
        }
        return (
            hasViewOrFullAccess(loggedinuser, "TAX RATES G&A TAX") ||
            hasViewOrFullAccess(loggedinuser, "TAX RATES TAX")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);
    const canSeeOperationsRates = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "OPERATIONS RATES HOURLY RATES & EXPENSES") ||
            hasViewOrFullAccess(loggedinuser, "SALES HOURLY RATES ADD HOURLY RATES")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    // L3 Settings: Add Member – show only if View Only or Full Access to any Add/Edit/Delete member
    const canSeeAddMember = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "ADD MEMBER ADD MEMBER") ||
            hasViewOrFullAccess(loggedinuser, "ADD MEMBER EDIT MEMBER") ||
            hasViewOrFullAccess(loggedinuser, "ADD MEMBER DELETE MEMBER")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    // L3 Settings: Sales Hourly Rates & Expenses – show only if View Only or Full Access
    const canSeeSalesHourlyRates = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "SALES HOURLY RATES ADD HOURLY RATES") ||
            hasViewOrFullAccess(loggedinuser, "SALES HOURLY RATES EDIT HOURLY RATES") ||
            hasViewOrFullAccess(loggedinuser, "SALES HOURLY RATES DELETE HOURLY RATES")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    // Settings modules (Admin/Director)
    // For these Admin/Director settings, require at least one FULL ACCESS sub-permission.
    const canSeeAddGroup = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "ADD GROUP ADD GROUP") ||
            hasViewOrFullAccess(loggedinuser, "ADD GROUP EDIT GROUP") ||
            hasViewOrFullAccess(loggedinuser, "ADD GROUP DELETE GROUP")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);
    const canSeeLeadType = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "LEAD TYPE ADD LEAD TYPE") ||
            hasViewOrFullAccess(loggedinuser, "LEAD TYPE EDIT LEAD TYPE") ||
            hasViewOrFullAccess(loggedinuser, "LEAD TYPE DELETE LEAD TYPE")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);
    const canSeeStatus = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "STATUS ADD STATUS") ||
            hasViewOrFullAccess(loggedinuser, "STATUS EDIT STATUS") ||
            hasViewOrFullAccess(loggedinuser, "STATUS DELETE STATUS")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);
    const canSeeSource = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "SOURCE ADD SOURCE") ||
            hasViewOrFullAccess(loggedinuser, "SOURCE EDIT SOURCE") ||
            hasViewOrFullAccess(loggedinuser, "SOURCE DELETE SOURCE")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    // Hardware manager: show menu if user has View Only or Full Access to any feature (strict featureAccess)
    const canSeeHardwareInventory = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "INVENTORY ADD INVENTORY") ||
            hasViewOrFullAccess(loggedinuser, "INVENTORY EDIT INVENTORY")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    const canSeeHardwareAssembly = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "ASSEMBLY ADD ASSEMBLY") ||
            hasViewOrFullAccess(loggedinuser, "ASSEMBLY EDIT ASSEMBLY") ||
            hasViewOrFullAccess(loggedinuser, "ASSEMBLY EDIT ASSEMNLY") ||
            hasViewOrFullAccess(loggedinuser, "ASSEMBLY DOWNLOAD ASSEMBLY") ||
            hasViewOrFullAccess(loggedinuser, "ASSEMBLY UPLOAD ASSEMBLY")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    const canSeeHardwareSubparts = useMemo(() => {
        if (!hasConfiguredFeatureAccess) return true;
        return (
            hasViewOrFullAccess(loggedinuser, "HARDWARE PARTS ADD HARDWARE PARTS") ||
            hasViewOrFullAccess(loggedinuser, "HARDWARE PARTS EDIT HARDWARE PARTS") ||
            hasViewOrFullAccess(loggedinuser, "HARDWARE PARTS DOWNLOAD HARDWARE PARTS") ||
            hasViewOrFullAccess(loggedinuser, "HARDWARE PARTS UPLOAD HARDWARE PARTS")
        );
    }, [hasConfiguredFeatureAccess, loggedinuser]);

    const canSeeHardwareSettings = canSeeHardwareAssembly || canSeeHardwareSubparts;

    // Process Guide visibility: only when subscription is ERP and user has full access to Process Guide
    const canSeeProcessGuide = useMemo(() => {
        if (packageData !== "ERP") return false;
        return hasViewOrFullAccess(loggedinuser, "PROCESS GUIDE ASSISTANCE");
    }, [packageData, loggedinuser]);

    // Process Guide: require explicit feature access even for L4 Operations role.
    // If feature is missing in featureAccess or marked No Access, keep it hidden.
    const isOperationsRole = useMemo(() => {
        const fromLoggedInUser = loggedinuser?.customRoles;
        const fromSession = session?.customRoles;
        const fromLocal = Roles; // legacy: sometimes stored as single string

        const toList = (v) => (Array.isArray(v) ? v : v ? [v] : []);
        const list = [...toList(fromLoggedInUser), ...toList(fromSession), ...toList(fromLocal)];

        return list.some((r) => {
            const s = String(r || "").toLowerCase();
            return s.includes("operations") || s.includes("project manager");
        });
    }, [loggedinuser, session, Roles]);

    const isOperationsPersonOnly = useMemo(() => {
        const toList = (v) => (Array.isArray(v) ? v : v ? [v] : []);
        const list = [
            ...toList(loggedinuser?.customRoles),
            ...toList(session?.customRoles),
            ...toList(Roles),
        ].map((r) => String(r || "").toLowerCase());
        const hasOps = list.some((r) => r.includes("operations"));
        const hasPm = list.some((r) => r.includes("project manager"));
        return loggedinuser?.EmpAuthLevel === "L4" && hasOps && !hasPm;
    }, [loggedinuser, session, Roles]);


    const handleGroupChange = (group) => {
        // Only switch selection when clicking a different group; re-clicking same group does not deselect
        dispatch(setSidebar(group));
    };

    const handleinventoryGroupChange = (groupId) => {
        // Always reset and reload inventory data per clicked group.
        dispatch(setSidebarInventoryGroup(""));
        dispatch(setSidebarInventoryGroup(groupId));
        dispatch(getInventoryByCreatedBy());
        dispatch(getAllAssemblyInventory());
        navigate("/dashboard/inventory");
    };
    const inventoryGroupOptions = useMemo(() => {
        const normalize = (value) => String(value ?? "").trim();
        const optionsFromSlice = Array.isArray(groupsFromSlice) ? groupsFromSlice : [];
        const groupMap = new Map();

        optionsFromSlice.forEach((groupItem) => {
            const id = normalize(groupItem?._id ?? groupItem?.id);
            if (!id) return;
            const displayName = normalize(
                groupItem?.name ??
                groupItem?.newGroupName ??
                groupItem?.groupName ??
                groupItem?.title ??
                id
            );
            groupMap.set(id, displayName || id);
        });

        const rawEmpGroups = Array.isArray(loggedinuser?.EmpGroups) ? loggedinuser.EmpGroups : [];
        return rawEmpGroups.map((entry) => {
            const groupId = normalize(entry?._id ?? entry?.id ?? entry);
            const fallbackLabel = normalize(entry?.name ?? entry?.newGroupName ?? entry?.groupName ?? entry);
            return {
                groupId,
                groupName: groupMap.get(groupId) || fallbackLabel || groupId,
            };
        }).filter((entry) => entry.groupId);
    }, [groupsFromSlice, loggedinuser]);
    return (
        <>
            {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}

            <div className="grid bg-white h-screen absolute">
                {modalOpen && (
                    <>
                        <style>
                            {`
        #menu-bar::-webkit-scrollbar {
          width: 8px; 
        }

        #menu-bar::-webkit-scrollbar-track {
          border-radius: 10px;
        }

        #menu-bar::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }

        #menu-bar::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        /* Simple horizontal scroll animation for Process Guide text when a bucket is active */
        @keyframes process-guide-marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }

        .animate-scroll-horizontal {
          animation: process-guide-marquee 8s linear infinite;
        }
      `}
                        </style>
                        <div
                            id="menu-bar"
                            className={`row-span-1 p-0.5 col-span-1 fixed shadow-2xl flex flex-col transition-all duration-300 ease-in-out top-0 bottom-0`}
                            style={{ width: modalOpen ? "17%" : "0%" }}
                        >
                            <div className="p-1 h-full bg-white flex flex-col border-r border-gray-200 overflow-hidden">
                                <div className="flex-shrink-0 relative z-10 bg-white overflow-hidden">
                                    {/* {(loggedinuser?.EmpAuthLevel === "L4" || loggedinuser?.EmpAuthLevel === "L2" || loggedinuser?.EmpAuthLevel === "L0") ? ( */}
                                    <div className=" flex justify-center items-center align-middle w-full p-2 cursor-pointer">
                                        <div
                                            onClick={ImageNavigate}
                                            className="w-full flex justify-center align-middle items-center p-3 cursor-pointer bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
                                        >
                                            <img
                                                onClick={ImageNavigate}
                                                src={logo}
                                                alt="Logo"
                                                className=" w-full cursor-pointer"
                                            />
                                        </div>
                                    </div>

                                </div>
                                <div className="flex-1 overflow-y-auto overflow-x-hidden flex flex-col justify-between min-h-0">
                                    <div className="flex flex-col w-full">
                                        <div className="w-full font-sans">

                                            <div className="text-gray-800">

                                                <div
                                                    onClick={() => {
                                                        // toggleSubMenu("Dashboard");
                                                        setShowContact(false);
                                                        setSelectedDash("")
                                                        setIsProcessGuideActive(false);
                                                        dispatch(clearActiveBucketName());
                                                        ImageNavigate()
                                                        dispatch(setcurrentLeadID());
                                                        dispatch(clearAllSidebarSelections());
                                                        // setShowInventory(false)
                                                        // setshowGroup(false)
                                                        // setshowoption(false)
                                                        setshowhardwaresetting(false)
                                                        setIsOpens(false)
                                                        setisOpenwizard(false)
                                                        setShowInventoryDropdown(false)
                                                        handleDeleteLeadID()
                                                        // Scroll to top of the page
                                                        window.scrollTo({ top: 0, behavior: "smooth" });

                                                    }}
                                                    className="flex justify-between cursor-pointer items-center h-9 px-3 py-1.5 mb-0.5 hover:bg-blue-50 rounded-lg transition-colors duration-150 group"
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-gray-700 group-hover:text-blue-600 transition-colors duration-150">
                                                            <HomeIcon fontSize="small" />
                                                        </span>
                                                        <span className="text-sm font-semibold text-gray-800 group-hover:text-blue-600 transition-colors duration-150">
                                                            Dashboard
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* {openSubMenus["Dashboard"] && ( */}
                                                <div className="ml-6 border-l-2 border-gray-200 pl-2 space-y-0.5 my-0.5">
                                                    {MenuArray.filter((menu) =>
                                                        canAccessMenuItem(menu)
                                                    ).map((menu, index) => {
                                                        const isSubMenuItem = menu.name === "Add Lead" || menu.name === "Lead Reports";
                                                        return (
                                                            <div key={index} className={isSubMenuItem ? "ml-4" : ""}>
                                                                <div
                                                                    onClick={() => {
                                                                        setisOpenwizard(false)
                                                                        setIsOpens(false)
                                                                        setIsProcessGuideActive(false)
                                                                        dispatch(clearActiveBucketName());
                                                                        handleDeleteLeadID()
                                                                        // Profit and Loss Tracker: clear activeSection first so P&L page always refetches fresh data on click
                                                                        if (menu.name === "Profit and Loss Tracker") {
                                                                            dispatch(setActiveSection(null));
                                                                            setTimeout(() => {
                                                                                dispatch(setActiveSection("Profit and Loss Tracker"));
                                                                                dispatch(invalidateLeadsCache());
                                                                                dispatch(fetchEmployeeAuthData()).then((result) => {
                                                                                    if (fetchEmployeeAuthData.fulfilled.match(result)) {
                                                                                        dispatch(fetchLeads());
                                                                                        return;
                                                                                    }
                                                                                    const role = localStorage.getItem("userRole") || localStorage.getItem("auth");
                                                                                    if (role && role !== "L3") {
                                                                                        dispatch(fetchLeads());
                                                                                    }
                                                                                });
                                                                                dispatch(fetchGroups());
                                                                                dispatch(setcurrentLeadID());
                                                                                dispatch(setScrollTarget("Profit and Loss Tracker"));
                                                                            // setTimeout(
                                                                            //     () => dispatch(clearScrollTarget()),
                                                                            //     400
                                                                            // );
                                                                            setTimeout(() => {
                                                                                const myRequestsSection = document.getElementById("manager-p-and-l");
                                                                                if (myRequestsSection) {
                                                                                    const y = myRequestsSection.getBoundingClientRect().top + window.scrollY - 10;
                                                                                    window.scrollTo({ top: y, behavior: "smooth" });
                                                                                } else {
                                                                                    setTimeout(
                                                                                        () => dispatch(clearScrollTarget()),
                                                                                        400
                                                                                    );
                                                                                }
                                                                            }, 100);
                                                                            }, 0);
                                                                        } else {
                                                                            dispatch(setActiveSection(menu.name));
                                                                            if (menu.name === "Operations Tracker") {
                                                                            dispatch(setcurrentLeadID());

                                                                            // Scroll to My Requests section
                                                                            setTimeout(() => {
                                                                                const myRequestsSection = document.getElementById("my-requests-section");
                                                                                if (myRequestsSection) {
                                                                                    const y = myRequestsSection.getBoundingClientRect().top + window.scrollY - 60;
                                                                                    window.scrollTo({ top: y, behavior: "smooth" });
                                                                                } else {
                                                                                    // Fallback to Operations Tracker scroll if My Requests not found
                                                                                    dispatch(setScrollTarget("Operations Tracker"));
                                                                                    setTimeout(
                                                                                        () => dispatch(clearScrollTarget()),
                                                                                        300
                                                                                    );
                                                                                }
                                                                            }, 100);
                                                                            } else {
                                                                                window.scrollTo({ top: 0, behavior: "smooth" });
                                                                            }
                                                                        }
                                                                        if (menu.SubMenu) {
                                                                            toggleSubMenu(menu.name);
                                                                        } else {
                                                                            navigate(menu.path);
                                                                        }
                                                                        setSelectedDash(menu.name);
                                                                    }}
                                                                    className={`${menu.isHeader
                                                                        ? "text-xs font-bold text-gray-500 uppercase tracking-wider cursor-default py-1.5 px-2.5 mt-1 mb-0.5" :
                                                                        selectedDash === menu.name
                                                                            ? "bg-blue-600 text-white cursor-pointer shadow-sm"
                                                                            : "text-gray-700 hover:bg-gray-100 cursor-pointer"
                                                                        } rounded-md py-1.5 px-2.5 flex items-center justify-between transition-all duration-150 text-sm font-medium`}
                                                                >
                                                                    <div className="flex items-center gap-2">
                                                                        <span>{menu.name}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {/* )} */}
                                            </div>
                                        </div>






                                        {/* Tool Guide — Operations Person: below Dashboard, above Contact Us */}
                                        {isOperationsPersonOnly && (
                                            <ToolGuideSidebarItem
                                                authLevel="L4_OPS"
                                                onActivate={() => {
                                                    setShowContact(false);
                                                    setIsProcessGuideActive(false);
                                                    setSelectedDash("");
                                                    setshowhardwaresetting(false);
                                                    setIsOpens(false);
                                                    setisOpenwizard(false);
                                                    setShowInventoryDropdown(false);
                                                    handleDeleteLeadID();
                                                    dispatch(clearActiveBucketName());
                                                }}
                                            />
                                        )}

                                        {canSeeWizard && (

                                            <div
                                                onClick={() => {
                                                    dispatch(setShowWizard(true))
                                                    wizardStateToClear()
                                                    setshowhardwaresetting(false)
                                                    setIsOpens(false)
                                                    setIsProcessGuideActive(false)
                                                    dispatch(setToolGuideActive(false))
                                                    setisOpenwizard(true)
                                                    handleDeleteLeadID()
                                                    dispatch(setcurrentLeadID())
                                                }}
                                                    className={`flex justify-between items-center cursor-pointer h-9 px-3 py-1.5 mt-1 hover:bg-blue-50 rounded-lg transition-colors duration-150 group ${isOpenwizard ? "bg-blue-50" : ""}`}
                                            >
                                                <div className={`flex items-center gap-3 ${isOpenwizard ? "text-blue-600" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`}>
                                                    <span>
                                                        <AutoFixHighIcon fontSize="small" />
                                                    </span>
                                                    <span className="text-sm font-semibold flex justify-center items-center">Wizard</span>
                                                </div>
                                            </div>
                                        )}

                                        {/* Tool Guide — between Wizard and Settings (Sales L3 first) */}
                                        {loggedinuser?.EmpAuthLevel === "L3" && (
                                            <ToolGuideSidebarItem
                                                authLevel="L3"
                                                onActivate={() => {
                                                    setShowContact(false);
                                                    setIsProcessGuideActive(false);
                                                    setSelectedDash("");
                                                    setshowhardwaresetting(false);
                                                    setIsOpens(false);
                                                    setisOpenwizard(false);
                                                    setShowInventoryDropdown(false);
                                                    handleDeleteLeadID();
                                                    dispatch(clearActiveBucketName());
                                                }}
                                            />
                                        )}

                                        {(Auth === "L4" && loggedinuser?.servicetype === "Hardware" && Roles !== "operations" && canSeeHardwareInventory) ? (
                                            <>
                                                <div className="flex flex-col w-full">
                                                    {/* Inventory Dropdown Header */}
                                                    <div
                                                        onClick={() => {
                                                            setShowInventoryDropdown(!showInventoryDropdown);
                                                            toggleSubMenu("");
                                                            setOpenSubMenus({}); // Close Settings when Inventory is clicked
                                                            setShowContact(false);
                                                            setshowhardwaresetting(false);
                                                            setIsOpens(false);
                                                            setIsProcessGuideActive(false);
                                                            handleDeleteLeadID();
                                                            setSelectedDash("");
                                                        }}
                                                        className={`flex justify-between items-center cursor-pointer h-9 px-3 py-1.5 mt-1 hover:bg-blue-50 rounded-lg transition-colors duration-150 group ${showInventoryDropdown ? "bg-blue-50 text-blue-600" : "text-gray-700 group-hover:text-blue-600"}`}
                                                    >
                                                        <div className="flex items-center gap-3 flex-1">
                                                            <span>
                                                                <InventoryIcon fontSize="small" />
                                                            </span>
                                                            <span className="text-sm font-semibold flex justify-center items-center">Inventory</span>
                                                        </div>
                                                        <span className={`${showInventoryDropdown ? "text-blue-600" : "text-gray-400"} transition-transform duration-150`}>
                                                            <IoIosArrowDown className={`${showInventoryDropdown ? "rotate-180" : ""} transition-transform duration-150`} />
                                                        </span>
                                                    </div>

                                                    {/* Inventory Dropdown Content */}
                                                    {showInventoryDropdown && (
                                                        <div className="ml-6 border-l-2 border-gray-200 pl-2 space-y-0.5 my-0.5">
                                                            {/* Group Dropdown */}
                                                            <div className="flex flex-col w-full">
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        toggleDropdowns();
                                                                    }}
                                                                    className={`flex w-full items-center gap-2 h-9 px-3 py-1.5 rounded-md cursor-pointer transition-colors duration-150 ${isOpens ? "bg-blue-50 text-blue-600" : "hover:bg-gray-50 text-gray-700"}`}
                                                                >
                                                                    <span>
                                                                        <GroupIcon fontSize="small" />
                                                                    </span>
                                                                    <span className="text-sm font-semibold flex-1">Group</span>
                                                                    <span className={`${isOpens ? "text-blue-600" : "text-gray-400"} transition-transform duration-150`}>
                                                                        <IoIosArrowDown className={`${isOpens ? "rotate-180" : ""} transition-transform duration-150`} />
                                                                    </span>
                                                                </div>
                                                                {isOpens && (
                                                                    <div className="w-full border-gray-200 pl-3 pt-0.5">
                                                                        <div className="bg-white rounded-md shadow-sm border-l-2 border-gray-100 max-h-[calc(100vh-450px)] overflow-y-auto overflow-x-hidden p-1">
                                                                            {inventoryGroupOptions.map(({ groupId, groupName }, index) => (
                                                                                <div
                                                                                    key={groupId || index}
                                                                                    onClick={() => {
                                                                                        handleinventoryGroupChange(groupId);
                                                                                    }}
                                                                                    className={`p-1.5 rounded-md cursor-pointer transition-colors duration-150 text-sm font-medium ${SidebarInventoryGroup === groupId
                                                                                        ? 'bg-blue-600 text-white border-blue-700 rounded-md'
                                                                                        : 'text-gray-700 hover:bg-gray-100 border-gray-300'
                                                                                        }`}
                                                                                >
                                                                                    {groupName}
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </>

                                        ) : (
                                            <>
                                            </>
                                        )}


                                        {/* Setting for other than hardware */}
                                        {(
                                            (Roles === "project manager" &&
                                                loggedinuser?.servicetype &&
                                                loggedinuser?.servicetype !== "Hardware") || (empAuthLevel === "L0" || empAuthLevel === "L1" || empAuthLevel === "L2" || empAuthLevel === "L3")
                                        ) && (
                                                <div className="text-gray-800  ">
                                                    <div
                                                        onClick={() => {
                                                        toggleSubMenu("Settings");
                                                        setShowContact(false);
                                                        setIsProcessGuideActive(false);
                                                        dispatch(setToolGuideActive(false));
                                                        dispatch(clearActiveBucketName());
                                                            dispatch(setcurrentLeadID());
                                                            dispatch(clearAllSidebarSelections());
                                                            // setShowInventory(false);
                                                            // setshowGroup(false)
                                                            // setshowoption(false)
                                                            setshowhardwaresetting(false)
                                                            setIsOpens(false)
                                                            setisOpenwizard(false)
                                                            setShowInventoryDropdown(false)
                                                            handleDeleteLeadID()

                                                        }}
                                                        className={`flex justify-between items-center cursor-pointer h-9 px-3 py-1.5 mt-1 hover:bg-blue-50 rounded-lg transition-colors duration-150 group ${openSubMenus["Settings"] ? "bg-blue-50" : ""}`}
                                                    >
                                                        <div className="flex items-center gap-3">
                                                            <span className={`${openSubMenus["Settings"] ? "text-blue-600" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`}>
                                                                <BusinessCenterIcon fontSize="small" />
                                                            </span>
                                                            <span className={`${openSubMenus["Settings"] ? "text-blue-600" : "text-gray-800 group-hover:text-blue-600 transition-colors duration-150"} text-sm font-semibold flex justify-center items-center`}>Settings</span>
                                                        </div>
                                                        <span className={`${openSubMenus["Settings"] ? "text-blue-600" : "text-gray-400"} transition-colors duration-150`}>
                                                            {openSubMenus["Settings"] ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                        </span>
                                                    </div>

                                                    {openSubMenus["Settings"] && (
                                                        <div className="ml-6 border-l-2 border-gray-200 pl-2 space-y-0.5 my-0.5">
                                                            {filteredSettingsMenu
                                                                .filter((item) => {
                                                                    if (item.name === "Subpart" && serviceType !== "Hardware") return false;
                                                                    if (item.name === "Assembly" && serviceType !== "Hardware") return false;
                                                                    if (item.name === "Group" && serviceType !== "Hardware") return false;
                                                                    if (item.name === "Client Ratings" && !canSeeClientRatings) return false;
                                                                    if (item.name === "Client Master" && !canSeeClientMaster) return false;
                                                                    if (item.name === "Quotation Template" && !canSeeQuotationTemplate) return false;
                                                                    if (item.name === "G&A and Tax Rates" && !canSeeTaxRates) return false;
                                                                    if (item.path === "/dashboard/hourly-rates-manager" && !canSeeOperationsRates) return false;
                                                                    if (item.name === "Add Member" && hasConfiguredFeatureAccess && !canSeeAddMember) return false;
                                                                    if (item.name === "Hourly Rates & Expenses" && item.path === "/dashboard/hourly-rates" && hasConfiguredFeatureAccess && !canSeeSalesHourlyRates) return false;
                                                                    if (item.name === "Company Profile") {
                                                                        // Always visible for Admin (L0). Hide for others.
                                                                        if (empAuthLevel !== "L0") return false;
                                                                    }
                                                                    if (item.name === "Add Group" && hasConfiguredFeatureAccess && !canSeeAddGroup) return false;
                                                                    if (item.name === "Lead Type" && hasConfiguredFeatureAccess && !canSeeLeadType) return false;
                                                                    if (item.name === "Status" && hasConfiguredFeatureAccess && !canSeeStatus) return false;
                                                                    if (item.name === "Source" && hasConfiguredFeatureAccess && !canSeeSource) return false;
                                                                    // Employees is always visible for Admin (L0) and Director (L1)
                                                                    if (item.name === "Employees" && !["L0", "L1"].includes(empAuthLevel)) return false;

                                                                    if (
                                                                        item.name === "Hourly Rates & Expenses" &&
                                                                        item.path === "/dashboard/hourly-rates" &&
                                                                        (loggedinuser?.customRoles?.includes("operations") ||
                                                                            loggedinuser?.servicetype === "Hardware")
                                                                    )
                                                                        return false;
                                                                    return item.permissionLevels?.includes(userLevel);
                                                                })
                                                                .map((item, index) => {
                                                                    const isClickable = item.permissionLevels?.includes(userLevel);

                                                                    const handleClick = () => {
                                                                        handleDeleteLeadID()
                                                                        setIsProcessGuideActive(false)
                                                                        if (isClickable) {
                                                                            if (item.name === "Hourly Rates & Expenses") {
                                                                                dispatch(setActiveSection("Hourly Rates & Expenses"));
                                                                            }
                                                                            navigate(item.path);
                                                                            setSelectedDash(item.name);
                                                                            dispatch(setcurrentLeadID());

                                                                        }
                                                                    };

                                                                    const isActive = selectedDash === item.name;

                                                                    return (
                                                                        <div
                                                                            key={index}
                                                                            onClick={handleClick}
                                                                            className={`flex items-center gap-2 rounded-md py-1.5 px-2.5 cursor-pointer transition-all duration-150
                                                                       ${isActive
                                                                                    ? "bg-blue-600 text-white shadow-sm"
                                                                                    : "text-gray-700 hover:bg-gray-100"
                                                                                }
                                                           ${!isClickable ? "cursor-default opacity-70" : ""}`}
                                                                        >
                                                                            <span className="text-sm font-medium">{item.name}</span>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    )}
                                                    {/* Process Guide – below Settings for L3 only; L0, L1, L2 do not see it; L4 uses standalone block below */}
                                                    {loggedinuser?.EmpAuthLevel === "L3" &&
                                                        canSeeProcessGuide && (
                                                        <div
                                                            onClick={() => {
                                                                setShowContact(false);
                                                                setIsProcessGuideActive(true);
                                                                setSelectedDash("");
                                                                setshowhardwaresetting(false);
                                                                setIsOpens(false);
                                                                setisOpenwizard(false);
                                                                setShowInventoryDropdown(false);
                                                                handleDeleteLeadID();
                                                                if (!activeBucketName) {
                                                                    dispatch(clearActiveBucketName());
                                                                }
                                                                navigate("/dashboard");
                                                                dispatch(setActiveSection("Operations Tracker"));
                                                                dispatch(setcurrentLeadID());
                                                                setTimeout(() => {
                                                                    const myRequestsSection = document.getElementById("my-requests-section");
                                                                    if (myRequestsSection) {
                                                                        const y = myRequestsSection.getBoundingClientRect().top + window.scrollY - 60;
                                                                        window.scrollTo({ top: y, behavior: "smooth" });
                                                                    } else {
                                                                        dispatch(setScrollTarget("Operations Tracker"));
                                                                        setTimeout(() => dispatch(clearScrollTarget()), 300);
                                                                    }
                                                                }, 100);
                                                            }}
                                                            onMouseEnter={() => {
                                                                if (activeBucketName) {
                                                                    setShowProcessGuidePanel(true);
                                                                    setSelectedGuideStep(activeBucketName);
                                                                }
                                                            }}
                                                            onMouseLeave={() => setShowProcessGuidePanel(false)}
                                                            className={`flex justify-between items-center h-9 cursor-pointer px-3 py-1.5 mt-1 rounded-lg transition-colors duration-150 group ${isProcessGuideActive ? "bg-blue-600 text-white shadow-sm" : "hover:bg-blue-50"}`}
                                                        >
                                                            <div className="flex items-center gap-3 overflow-hidden">
                                                                <MenuBookOutlinedIcon className={`flex-shrink-0 ${isProcessGuideActive ? "text-white" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`} fontSize="small" />
                                                                <div className="relative w-[140px] h-5 overflow-hidden">
                                                                    <div className={`whitespace-nowrap text-sm font-semibold ${isProcessGuideActive ? "text-white" : "text-gray-800 group-hover:text-blue-600 transition-colors duration-150"} ${activeBucketName ? "animate-scroll-horizontal" : ""}`} key={activeBucketName || "Process Guide"}>
                                                                        {activeBucketName || "Process Guide"}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                        {/* Setting for Hardware */}
                                        {(loggedinuser?.EmpAuthLevel === "L4" && loggedinuser?.servicetype === "Hardware" && Roles !== "operations" && canSeeHardwareSettings) ? (
                                            <div className="">
                                                <div
                                                    onClick={() => {
                                                        setshowhardwaresetting(!showhardwaresetting)
                                                        setIsOpens(false)
                                                        setIsProcessGuideActive(false)
                                                        dispatch(clearActiveBucketName());
                                                        handleDeleteLeadID()
                                                    }}
                                                    className={`flex justify-between items-center cursor-pointer h-11 px-4 py-2.5 mt-2 hover:bg-blue-50 rounded-lg transition-colors duration-150 group ${showhardwaresetting ? "bg-blue-50" : ""}`}
                                                >
                                                    <div className={`flex items-center gap-3 ${showhardwaresetting ? "text-blue-600" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`}>
                                                        <span>
                                                            <BusinessCenterIcon fontSize="small" />
                                                        </span>
                                                        <span className="text-sm font-semibold flex justify-center items-center">Settings</span>
                                                    </div>
                                                    <span className={`${showhardwaresetting ? "text-blue-600" : "text-gray-400"} transition-colors duration-150`}>
                                                        {showhardwaresetting ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    </span>
                                                </div>
                                                {showhardwaresetting && (
                                                    <div ref={dropdownRef} className="ml-8 border-l-2 border-gray-200 pl-2 space-y-0.5 my-0.5">
                                                        {/* Group Selection */}
                                                        <div
                                                            onClick={toggleDropdown}
                                                            className={`flex items-center gap-2 h-9 px-3 py-1.5 rounded-md cursor-pointer transition-colors duration-150 ${isOpen ? "bg-blue-50 text-blue-600" : "hover:bg-gray-50 text-gray-700"}`}
                                                        >
                                                            <span className="text-sm font-semibold flex-1">Group</span>
                                                            <span className={`${isOpen ? "text-blue-600" : "text-gray-400"} transition-transform duration-150`}>
                                                                <IoIosArrowDown className={`${isOpen ? "rotate-180" : ""} transition-transform duration-150`} />
                                                            </span>
                                                        </div>

                                                        {isOpen && (
                                                            <div className="space-y-0.5">
                                                                <div className="bg-white rounded-md shadow-sm border border-gray-100 max-h-[calc(100vh-400px)] overflow-y-auto overflow-x-hidden">
                                                                    {inventoryGroupOptions.map(({ groupId, groupName }, index) => (
                                                                        <div key={index}>
                                                                            <div
                                                                                onClick={() => handleGroupChange(groupId)}
                                                                                className={`px-3 py-1.5 cursor-pointer transition-colors duration-150 text-sm font-medium ${SidebarGroup === groupId
                                                                                    ? 'bg-blue-600 text-white rounded-md'
                                                                                    : 'text-gray-700 hover:bg-gray-100'
                                                                                    } ${index === 0 ? 'rounded-t-md' : ''} ${index === inventoryGroupOptions.length - 1 && !SidebarGroup ? 'rounded-b-md' : ''}`}
                                                                            >
                                                                                {groupName}
                                                                            </div>
                                                                            {SidebarGroup === groupId && (
                                                                                <div className="bg-gray-50 border-t border-gray-200">
                                                                                    {canSeeHardwareAssembly && (
                                                                                        <div
                                                                                            onClick={() => {
                                                                                                navigate("/dashboard/assembly");
                                                                                                setselectedGroupoption("Assembly");
                                                                                            }}
                                                                                            className={`px-5 py-1.5 cursor-pointer transition-colors duration-150 text-sm font-medium ${selectedGroupoption === "Assembly"
                                                                                                ? 'text-blue-600 bg-blue-50'
                                                                                                : 'text-gray-700 hover:bg-gray-100'
                                                                                                }`}
                                                                                        >
                                                                                            Assembly
                                                                                        </div>
                                                                                    )}
                                                                                    {canSeeHardwareSubparts && (
                                                                                        <div
                                                                                            onClick={() => {
                                                                                                navigate("/dashboard/hardware");
                                                                                                setselectedGroupoption("Subparts");
                                                                                            }}
                                                                                            className={`px-5 py-1.5 cursor-pointer transition-colors duration-150 text-sm font-medium rounded-b-md ${selectedGroupoption === "Subparts"
                                                                                                ? 'text-blue-600 bg-blue-50'
                                                                                                : 'text-gray-700 hover:bg-gray-100'
                                                                                                }`}
                                                                                        >
                                                                                            Subparts
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                        {/* Process Guide for L4 operation person & project manager (all service types) – single block so check applies for both */}
                                        {loggedinuser?.EmpAuthLevel === "L4" && isOperationsRole && canSeeProcessGuide && (
                                                <div className="text-gray-800">
                                                    <div
                                                        onClick={() => {
                                                            setShowContact(false);
                                                            setIsProcessGuideActive(true);
                                                            dispatch(setToolGuideActive(false));
                                                            setSelectedDash("");
                                                            setshowhardwaresetting(false);
                                                            setIsOpens(false);
                                                            setisOpenwizard(false);
                                                            setShowInventoryDropdown(false);
                                                            handleDeleteLeadID();
                                                            if (!activeBucketName) dispatch(clearActiveBucketName());
                                                            navigate("/dashboard");
                                                            dispatch(setActiveSection("Operations Tracker"));
                                                            dispatch(setcurrentLeadID());
                                                            setTimeout(() => {
                                                                const myRequestsSection = document.getElementById("my-requests-section");
                                                                if (myRequestsSection) {
                                                                    const y = myRequestsSection.getBoundingClientRect().top + window.scrollY - 60;
                                                                    window.scrollTo({ top: y, behavior: "smooth" });
                                                                } else {
                                                                    dispatch(setScrollTarget("Operations Tracker"));
                                                                    setTimeout(() => dispatch(clearScrollTarget()), 300);
                                                                }
                                                            }, 100);
                                                        }}
                                                        onMouseEnter={() => { if (activeBucketName) { setShowProcessGuidePanel(true); setSelectedGuideStep(activeBucketName); } }}
                                                        onMouseLeave={() => setShowProcessGuidePanel(false)}
                                                        className={`flex justify-between items-center h-9 cursor-pointer px-3 py-1.5 mt-1 rounded-lg transition-colors duration-150 group ${isProcessGuideActive ? "bg-blue-600 text-white shadow-sm" : "hover:bg-blue-50"}`}
                                                    >
                                                        <div className="flex items-center gap-3 overflow-hidden">
                                                            <MenuBookOutlinedIcon className={`flex-shrink-0 ${isProcessGuideActive ? "text-white" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`} fontSize="small" />
                                                            <div className="relative w-[140px] h-5 overflow-hidden">
                                                                <div className={`whitespace-nowrap text-sm font-semibold ${isProcessGuideActive ? "text-white" : "text-gray-800 group-hover:text-blue-600 transition-colors duration-150"} ${activeBucketName ? "animate-scroll-horizontal" : ""}`} key={activeBucketName || "Process Guide"}>{activeBucketName || "Process Guide"}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        {/* Process Guide hover panel (portal) – menu row is directly below Settings */}
                                        {canSeeProcessGuide &&
                                            showProcessGuidePanel &&
                                            activeBucketName &&
                                            createPortal(
                                                    <>
                                                        {/* Backdrop overlay - dims the background content */}
                                                        <div
                                                            className="fixed inset-0 left-[17%] bg-black/40"
                                                            style={{ zIndex: 999998 }}
                                                            onClick={() => setShowProcessGuidePanel(false)}
                                                        />
                                                        {/* Blue guide positioned to the right of sidebar, in main content area */}
                                                        <div
                                                            className={`fixed left-[18%] shadow-2xl rounded-xl overflow-hidden bg-gradient-to-b from-blue-700 to-blue-500 border border-blue-800 ${activeBucketName === "Project Ongoing" && loggedinuser?.EmpAuthLevel === "L4" && loggedinuser?.customRoles?.includes("project manager") ? "top-[120px]" : "top-[200px]"}`}
                                                            style={{ zIndex: 999999 }}
                                                            onMouseEnter={() => setShowProcessGuidePanel(true)}
                                                            onMouseLeave={() => setShowProcessGuidePanel(false)}
                                                        >
                                                        {/* Blue guide box with steps */}
                                                        <div className="w-[340px] text-white flex flex-col p-5">
                                                            <h3 className="text-[15px] font-bold tracking-wider mb-4 text-white uppercase">
                                                                Operations Guide
                                                            </h3>
                                                            
                                                            {/* Step header - dynamic based on bucket */}
                                                            {activeBucketName === "Project Requests Outstanding" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 1</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Project Request</div>
                                                                    <div className="text-[11px] text-blue-600 mt-1 font-semibold">Project Requests Outstanding</div>
                                                                </div>
                                                            )}
                                                            {activeBucketName === "Response Received" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 2</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Response Received</div>
                                                                    <div className="text-[11px] text-blue-600 mt-1 font-semibold">Response Received (RR)</div>
                                                                </div>
                                                            )}
                                                            {activeBucketName === "Project Approved" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 3</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Project Approved</div>
                                                                </div>
                                                            )}
                                                            {activeBucketName === "Project Assigned" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 4</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Project Assigned</div>
                                                                </div>
                                                            )}
                                                            {activeBucketName === "Project Ongoing" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 5</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Project Ongoing</div>
                                                                </div>
                                                            )}
                                                            {activeBucketName === "Project Completed" && (
                                                                <div className="text-left rounded-lg px-4 py-3 mb-4 bg-white text-blue-700 shadow-sm">
                                                                    <div className="text-[11px] uppercase tracking-widest opacity-80 font-semibold">Step 6</div>
                                                                    <div className="text-[16px] font-bold mt-0.5">Project Completed</div>
                                                                </div>
                                                            )}

                                                            {/* Guide steps content - dynamic based on bucket */}
                                                            <div className="space-y-2.5 text-[13px] leading-relaxed text-white/90">
                                                                {/* Project Requests Outstanding */}
                                                                {activeBucketName === "Project Requests Outstanding" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsManager) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Requests</div>
                                                                                            <div>→ Select Action → Choose Option</div>
                                                                                            <div>→ Forward / Reject</div>
                                                                                            <div className="mt-2 font-medium text-white/95">If Forward:</div>
                                                                                            <div>→ Assign tasks to employees</div>
                                                                                            <div>→ Complete own tasks (assign to ops team if required)</div>
                                                                                            <div>→ After ops team submission → Review via Actions</div>
                                                                                            <div>→ Take Action: Review / Complete / Cancel</div>
                                                                                            <div>→ If Review → Wait for corrections</div>
                                                                                            <div>→ If Completed → Response sent to Sales Person</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else if (isOperationsPerson) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Requests</div>
                                                                                            <div>→ Select Action → Choose Option</div>
                                                                                            <div>→ Accept / Reject</div>
                                                                                            <div>→ If Accepted → Complete own task list</div>
                                                                                            <div>→ Submit</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Outstanding</div>
                                                                                            <div>→ Select project name</div>
                                                                                            <div>→ Open dropdown (manager list)</div>
                                                                                            <div>→ Assign (choose primary manager – optional secondary)</div>
                                                                                            <div>→ Forward (or cancel if required)</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                                
                                                                {/* Response Received */}
                                                                {activeBucketName === "Response Received" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsManager || isOperationsPerson) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Overview:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Leads move here once all selected managers complete their initial tasks.</div>
                                                                                            <div className="mt-2 font-medium text-white/95">Action Options:</div>
                                                                                            <div>→ Accept: Values appear in P&L table once all PMs accept</div>
                                                                                            <div>→ Reject: Lead sent back to <span className="font-semibold">Outstanding</span> basket</div>
                                                                                            <div>→ Cancel: Specific PM for that service is removed</div>
                                                                                            <div className="mt-2 font-medium text-white/95">Finalizing:</div>
                                                                                            <div>→ Create quotation → Update status to "Won" or "Won Recurring"</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Response Received</div>
                                                                                            <div>→ Select project</div>
                                                                                            <div>→ View details</div>
                                                                                            <div>→ Accept / Reject</div>
                                                                                            <div>→ Generate quotation</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                                
                                                                {/* Project Approved */}
                                                                {activeBucketName === "Project Approved" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsManager) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Approved</div>
                                                                                            <div>→ Select multiple projects</div>
                                                                                            <div>→ View task details</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else if (isOperationsPerson) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Approved</div>
                                                                                            <div>→ Select multiple projects</div>
                                                                                            <div>→ View task details</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Approved</div>
                                                                                            <div>→ Select project → View details</div>
                                                                                            <div>→ Accept / Reject</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                                
                                                                {/* Project Assigned */}
                                                                {activeBucketName === "Project Assigned" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsManager) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Assigned</div>
                                                                                            <div>→ Select multiple (Task Details)</div>
                                                                                            <div>→ Assign tasks to operations team</div>
                                                                                            <div>→ Edit tasks or keep as assigned</div>
                                                                                            <div>→ Manage own and team tasks as required</div>
                                                                                            <div>→ After all task submissions → Submit Project</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else if (isOperationsPerson) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Assigned</div>
                                                                                            <div>→ Select Action (Accept / Reject)</div>
                                                                                            <div>→ If Accepted → Edit or keep task details</div>
                                                                                            <div>→ Submit</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Assigned</div>
                                                                                            <div>→ Select project → View details</div>
                                                                                            <div>→ Accept / Reject</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                                
                                                                {/* Project Ongoing */}
                                                                {activeBucketName === "Project Ongoing" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsManager) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Ongoing</div>
                                                                                            <div>→ Select multiple (Task Details)</div>
                                                                                            <div>→ Complete own and team tasks</div>
                                                                                            <div>→ After all submissions → Submit Project</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else if (isOperationsPerson) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Ongoing</div>
                                                                                            <div>→ Select multiple (Task Details)</div>
                                                                                            <div>→ Complete own task details</div>
                                                                                            <div>→ Submit</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Ongoing</div>
                                                                                            <div>→ Select project → View details</div>
                                                                                            <div>→ Mark Approved Completion</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                                
                                                                {/* Project Completed */}
                                                                {activeBucketName === "Project Completed" && (
                                                                    <>
                                                                        {(() => {
                                                                            const customRoles = Array.isArray(loggedinuser?.customRoles) ? loggedinuser.customRoles : typeof loggedinuser?.customRoles === "string" ? [loggedinuser.customRoles] : [];
                                                                            const isOperationsPerson = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("operations") && !customRoles.includes("project manager");
                                                                            const isOperationsManager = loggedinuser?.EmpAuthLevel === "L4" && customRoles.includes("project manager");
                                                                            
                                                                            if (isOperationsPerson || isOperationsManager) {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Completed</div>
                                                                                            <div>→ Select multiple (Task Details)</div>
                                                                                            <div>→ View Details</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <div>
                                                                                        <div className="font-semibold text-white text-[13px] mb-2">Process Flow:</div>
                                                                                        <div className="pl-3 space-y-1 text-white/85">
                                                                                            <div>Project Completed</div>
                                                                                            <div>→ Select project → View details</div>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </>,
                                                    document.body
                                                )}

                                        {/* Packages section - hidden for L4 auth level */}
                                        {Auth !== "L4" && (
                                            <div className="w-full px-2 py-2">
                                                <div className={`w-full bg-white text-gray-800 rounded-lg border border-gray-200 ${isL0User ? "p-3" : "px-3 py-2"}`}>
                                                    <div className={`flex justify-between align-middle items-center ${isL0User ? "py-2" : "py-0.5"}`}>
                                                        <span className="text-sm font-semibold text-gray-800">Packages</span>
                                                        {isL0User ? (
                                                            packageData !== "ERP" ? (
                                                                <button
                                                                    onClick={() => setIsModalOpen(true)}
                                                                    className="text-xs px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-150"
                                                                >
                                                                    Upgrade
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    onClick={() => setIsModalOpen(true)}
                                                                    className="text-xs px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors duration-150"
                                                                >
                                                                    Edit
                                                                </button>
                                                            )
                                                        ) : (
                                                            <div className="flex overflow-hidden gap-1">
                                                                {(selectedPackages.length ? selectedPackages : ["ERP"]).map((pkg) => (
                                                                    <span
                                                                        key={pkg}
                                                                        className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium"
                                                                    >
                                                                        {pkg}
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {isL0User && <hr className="border-gray-300 my-2" />}
                                                    <div className="p-2 w-full flex flex-wrap gap-1">
                                                        {isL0User ? (
                                                            packageData ? (
                                                                <div className="flex overflow-hidden gap-1">
                                                                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                                                                        {packageData}
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <span className="text-sm text-gray-600">Select Packages</span>
                                                            )
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {/* Tool Guide — Operations Manager: between Settings and Contact Us */}
                                        {loggedinuser?.EmpAuthLevel === "L4" &&
                                            (Array.isArray(loggedinuser?.customRoles)
                                                ? loggedinuser.customRoles
                                                : [loggedinuser?.customRoles]
                                            ).some(
                                                (r) =>
                                                    String(r || "")
                                                        .trim()
                                                        .toLowerCase() === "project manager"
                                            ) && (
                                                <ToolGuideSidebarItem
                                                    authLevel="L4_PM"
                                                    onActivate={() => {
                                                        setShowContact(false);
                                                        setIsProcessGuideActive(false);
                                                        setSelectedDash("");
                                                        setshowhardwaresetting(false);
                                                        setIsOpens(false);
                                                        setisOpenwizard(false);
                                                        setShowInventoryDropdown(false);
                                                        handleDeleteLeadID();
                                                        dispatch(clearActiveBucketName());
                                                    }}
                                                />
                                            )}

                                        <div className="text-gray-800 ">
                                            <div
                                                onClick={() => {
                                                    setShowContact((prev) => !prev);
                                                    setIsProcessGuideActive(false);
                                                    dispatch(setToolGuideActive(false));
                                                    dispatch(clearActiveBucketName());
                                                    toggleSubMenu("Contact Us");
                                                    dispatch(setcurrentLeadID());
                                                    // setShowInventory(false)
                                                    // setshowGroup(false)
                                                    // setshowoption(false)
                                                    setshowhardwaresetting(false)
                                                    setIsOpens(false)
                                                    setisOpenwizard(false)
                                                    setShowInventoryDropdown(false)
                                                    setShowInventoryDropdown(false)

                                                }}
                                                className={`flex justify-between items-center h-9 cursor-pointer px-3 py-1.5 mt-1 hover:bg-blue-50 rounded-lg transition-colors duration-150 group ${showContact ? "bg-blue-50" : ""}`}
                                            >
                                                <div className="flex items-center gap-3">
                                                    <span className={`${showContact ? "text-blue-600" : "text-gray-700 group-hover:text-blue-600 transition-colors duration-150"}`}>
                                                        <ContactMailIcon fontSize="small" />
                                                    </span>
                                                    <span className={`${showContact ? "text-blue-600" : "text-gray-800 group-hover:text-blue-600 transition-colors duration-150"} text-sm font-semibold`}>Contact Us</span>
                                                </div>
                                                <span className={`${showContact ? "text-blue-600" : "text-gray-400"} transition-colors duration-150`}>
                                                    {showContact ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                </span>
                                            </div>

                                            {showContact && (
                                                <div className="ml-6 border-l-2 border-gray-200 pl-3 my-1 bg-white rounded-md px-4 py-3 shadow-sm">
                                                    <p className="text-sm text-gray-700 break-all">
                                                        <a
                                                            href="mailto:support@indusinformatics.com"
                                                            className="text-blue-600 hover:text-blue-700 hover:underline transition-colors duration-150 font-medium"
                                                        >
                                                            support@indusinformatics.com
                                                        </a>
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="w-full flex-shrink-0">
                                        <div className="w-full bg-white p-3 flex justify-center items-center rounded-b-lg border-t border-gray-200">
                                            {profiles[0]?.logoPath ? (
                                                <img
                                                    className="w-full h-auto max-h-24 object-contain"
                                                    src={profiles[0]?.logoPath}
                                                    alt="Company Logo"
                                                />
                                            ) : (
                                                <h1 className="font-semibold text-lg text-gray-600">Company Logo</h1>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div >
                    </>
                )}

                {
                    showWizard && (

                        <div ref={wizardRef}>
                            <Wizard />
                        </div>
                    )
                }

                {
                    isModalOpen && (
                        <div className="fixed inset-0 flex items-center justify-center z-[1400] bg-black bg-opacity-50">
                            <div className="bg-white  rounded-lg shadow-lg p-6 w-[90%] max-w-md">

                                {packageData !== "ERP" ? (
                                    <h2 className="text-xl font-semibold mb-4 text-center">
                                        Upgrade The Package
                                    </h2>
                                ) : (
                                    <h2 className="text-xl font-semibold mb-4 text-center">
                                        Edit The Package
                                    </h2>
                                )}
                                <div className="flex justify-center align-middle items-center w-full">
                                    <div
                                        className="pt-1 mb-4 w-[70%]"
                                    >
                                        <div className="">
                                            <div
                                                ref={dropdownRefService}
                                                className="relative flex  p-0  rounded-xl align-middle items-center"
                                            >
                                                <ExpandMoreIcon
                                                    color="white"
                                                    className="absolute cursor-pointer right-2 m-auto bg-white"
                                                    onClick={() =>
                                                        setShowServiceDropdown(!showServiceDropdown)
                                                    }
                                                />

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setShowServiceDropdown(!showServiceDropdown)
                                                    }
                                                    className="border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none"
                                                >

                                                    {selectedServiceTypes ? (
                                                        <div className="flex overflow-hidden gap-1">
                                                            <span
                                                                className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs"
                                                            >
                                                                {selectedServiceTypes}
                                                            </span>

                                                        </div>
                                                    ) : (
                                                        <span className="">Select Packages</span>
                                                    )}
                                                </button>

                                                {showServiceDropdown && (
                                                    <div
                                                        style={{ zIndex: 9999 }}
                                                        className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                                    >

                                                        <div
                                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                                            onClick={() => handlePackageSelection("CRM")}
                                                        >
                                                            CRM (Lead Tracker)
                                                        </div>
                                                        <div
                                                            className="p-1 hover:bg-gray-200 cursor-pointer"
                                                            onClick={() => handlePackageSelection("ERP")}

                                                        >
                                                            ERP (Finance + Operations Tracker)
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex justify-end gap-3">
                                    <button
                                        onClick={() => setIsModalOpen(false)}
                                        className="px-4 py-2 rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 text-gray-700"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleProfile}
                                        className="px-4 py-2 rounded-md bg-[#e32278] hover:bg-red-700 text-white font-semibold"
                                    >

                                        <p> Switch </p>

                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div >
        </>
    );
};

export default SidebarNew;